import * as actionTypes from '../constants/actionType';
import initialState from './initialState';

export default function mLatestEventsReducer(state = initialState.mLatestEvents, action) {
  switch (action.type) {
    case actionTypes.MLATESTEVENTS_LOAD_START:
      return {
        ...state,
        isLoading: true
      };

    case actionTypes.MLATESTEVENTS_LOAD_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error
      };

    case actionTypes.MLATESTEVENTS_LOAD_SUCCESS: {
      return {
        ...state,
        ...action.data,
        isLoading: false,
        error: undefined
      };
    }

    default:
      return state;
  }
}
